/**
 * Single source of truth สำหรับ Stock POS permissions/roles (โปรเจกต์ Stock_POS)
 * Admin ERP ใช้ bridge นี้เพื่อ merge RBAC ลง DB ร่วมกัน
 */
export {
  Permissions as StockPermissions,
  STOCK_MODULE_PERMISSION_IDS,
  RESOURCE_LABELS as STOCK_RESOURCE_LABELS,
  ACTION_LABELS as STOCK_ACTION_LABELS,
  parsePermissionId as parseStockPermissionId,
} from "../../../../../../Stock_POS/src/modules/roles/domain/contracts/permissions";

export {
  Roles as StockRoles,
  STOCK_ROLE_IDS,
} from "../../../../../../Stock_POS/src/modules/roles/domain/contracts/roles";
